import { createContext, useContext } from 'react';

/**
 * "Is this table subtree the one the player is actually on?"
 *
 * The single-table carousel keeps more than one table mounted: the outgoing one
 * while a slide runs, and (see RebindingTableView's keep-alive) the tables the
 * player recently switched away from, so switching back costs no remount. Those
 * extra subtrees must be inert — they may not talk to the engine, make noise, or
 * animate — while still applying state so they are correct the instant they are
 * shown again.
 *
 * Defaults to `true` so every surface without a provider behaves exactly as
 * before: the multi-table grid (each cell is a table the player IS looking at),
 * storybook, the demo table, and tests.
 */
export const TableActiveContext = createContext<boolean>(true);

export const TableActiveProvider = TableActiveContext.Provider;

/** True when this subtree is the table the player is on. */
export const useIsActiveTable = (): boolean => useContext(TableActiveContext);

export default TableActiveContext;
